module.exports = __webpack_public_path__ + "img/orange-1.cb1acfa0.png";